import React from 'react'
import { CardHeader, Typography, Box, useTheme, styled } from '@mui/material'
import HeaderBgImage from './header-bg.png'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import { Tooltip } from 'packages/eid-ui'
import config from 'config'

const MyCardHeader = styled(CardHeader)(({ theme }) => ({
    padding: 0,
    width: '100%',
    overflow: 'hidden',
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
    '& .MuiCardHeader-content': {
        width: '100%',
    },
    '& .MuiCardHeader-title': {
        fontSize: '24px',
        fontWeight: '600',
    },
}))
const tooltipStyles = {
    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
    padding: '8px',
    maxWidth: '500px',
}

const ItemHeader = ({ title, url, iconComponent, showIcon }) => {
    const isSmallScreen = useIsSmallScreen()
    const theme = useTheme()
    const maxCharacters = isSmallScreen ? 40 : 120
    let titleText = isNilOrEmpty(title) ? '' : title
    titleText =
        titleText.length > maxCharacters
            ? `${titleText.substring(0, maxCharacters)}...`
            : titleText

    const titleJsx = (
        <Typography
            sx={{
                width: '100%',
                height: '100%',
                zIndex: 1,
                overflow: 'hidden',
                maxWidth: '690px',
                letterSpacing: '0.0648rem',
            }}
            style={{
                fontWeight: 'bold',
                fontSize: '2.7rem',
                lineHeight: '3.8rem',
                color: theme?.palette?.common?.white,
                display: 'block',
                wordBreak: 'break-word',
                wordWrap: 'break-word',
                marginLeft: url || showIcon ? '8rem' : '0',
            }}
        >
            {titleText}
        </Typography>
    )

    let wrappedTitle

    if (titleText.length > maxCharacters) {
        wrappedTitle = (
            <Tooltip
                title={title}
                color="#5D6870"
                fontColor={theme?.palette?.common?.white}
                enterDelay={500}
                enterNextDelay={500}
                disableInteractive={false}
                tooltipStyles={tooltipStyles}
            >
                {titleJsx}
            </Tooltip>
        )
    } else {
        wrappedTitle = titleJsx
    }

    return (
        <MyCardHeader
            isSmallScreen={isSmallScreen}
            title={
                <Box
                    sx={{
                        position: 'relative',
                        padding: '2rem',
                        paddingTop: '1.8rem',
                        paddingLeft: '3.2rem',
                        paddingRight: '1.6rem',
                        minHeight: '9.5rem',
                        width: '100%',
                    }}
                    display="flex"
                    alignItems="center"
                    overflow="hidden"
                    style={{
                        background: theme?.palette?.primary?.main,
                    }}
                >
                    {wrappedTitle}
                    {url && (
                        <Box
                            sx={{
                                position: 'absolute',
                                zIndex: 1,
                                left: 5,
                                top: -4,
                                width: '88px',
                                height: '88px',
                                boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.05)',
                                border: 'solid 1px rgba(0, 0, 0, 0.15)',
                                borderRadius: '50%',
                                backgroundColor: theme?.palette?.common?.white,
                                padding: '24px',
                            }}
                        >
                            <img
                                style={{
                                    height: '37px',
                                    width: '37px',
                                }}
                                src={url}
                                alt="header icon"
                            />
                        </Box>
                    )}
                    {showIcon && (
                        <Box
                            sx={{
                                position: 'absolute',
                                zIndex: 1,
                                left: 5,
                                top: -4,
                                width: '88px',
                                height: '88px',
                                boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.05)',
                                border: 'solid 1px rgba(0, 0, 0, 0.15)',
                                borderRadius: '50%',
                                backgroundColor: theme?.palette?.common?.white,
                                padding: '24px',
                            }}
                            style={{ padding: '30px' }}
                        >
                            {iconComponent}
                        </Box>
                    )}

                    <img
                        style={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            zIndex: 0,
                            right: 0,
                            top: 0,
                            borderRadius: '8px',
                        }}
                        src={`${config.APP_SUBPATH}${HeaderBgImage}`}
                        alt="background"
                    />
                </Box>
            }
        />
    )
}

export default ItemHeader
